import { useMemo, useState } from "react";
import { Table } from "react-bootstrap";
import { useRegistrationCancellationReportUIContext } from "../RegistrationCancellationReportUIContext";

export function FilterButtonsTable() {
  // Registration Cancellation Report UI Context
  const cancellationReportUIContext = useRegistrationCancellationReportUIContext();
  const cancellationReportUIProps = useMemo(() => {
    return {
      columns: cancellationReportUIContext.columns,
      setColumns: cancellationReportUIContext.setColumns
    };
  }, [cancellationReportUIContext]);

  const [photoStyle, setPhotoStyle] = useState("light");
  const [termStyle, setTermStyle] = useState("light");
  const [dateStyle, setDateStyle] = useState("light");
  const [gradeLevelNameStyle, setGradeLevelNameStyle] = useState("light");
  const [gradeStyle, setGradeStyle] = useState("light");
  const [studentNumberStyle, setStudentNumberStyle] = useState("light");
  const [tcKimlikNoStyle, setTcKimlikNoStyleStyle] = useState("light");
  const [nameStyle, setNameStyle] = useState("light");
  const [surnameStyle, setSurnameStyle] = useState("light");
  const [sexNameStyle, setSexNameStyle] = useState("light");  
  const [addressStyle, setAddressStyle] = useState("success");
  const [fatherNameStyle, setFatherNameStyle] = useState("success");
  const [motherNameStyle, setMotherNameStyle] = useState("success");  
  const [fatherPhoneStyle, setFatherPhoneStyle] = useState("success");
  const [motherPhoneStyle, setMotherPhoneStyle] = useState("success");
  const [fatherOccupationStyle, setFatherOccupationStyle] = useState("success");
  const [motherOccupationStyle, setMotherOccupationStyle] = useState("success");
  const [phoneStyle, setPhoneStyle] = useState("success");
  const [explanationStyle, setExplanationStyle] = useState("success");

  /** */
  const setButtonStyle = (dataField) => {
    if (dataField === "photoStr") return setPhotoStyle;
    else if (dataField === "term") return setTermStyle;
    else if (dataField === "date") return setDateStyle;
    else if (dataField === "gradeLevelName") return setGradeLevelNameStyle;
    else if (dataField === "grade") return setGradeStyle;
    else if (dataField === "studentNumber") return setStudentNumberStyle;
    else if (dataField === "identityCard.tcKimlikNo") return setTcKimlikNoStyleStyle;
    else if (dataField === "identityCard.name") return setNameStyle;
    else if (dataField === "identityCard.surname") return setSurnameStyle;
    else if (dataField === "sexName") return setSexNameStyle;
    else if (dataField === "address") return setAddressStyle;
    else if (dataField === "father.name") return setFatherNameStyle;
    else if (dataField === "mother.name") return setMotherNameStyle;
    else if (dataField === "father.phone1") return setFatherPhoneStyle;
    else if (dataField === "mother.phone1") return setMotherPhoneStyle;
    else if (dataField === "father.occupation") return setFatherOccupationStyle;
    else if (dataField === "mother.occupation") return setMotherOccupationStyle;
    else if (dataField === "phone") return setPhoneStyle;
    else if (dataField === "explanation") return setExplanationStyle;
  }

  /** */
  const toggleHidden = (dataField) => {
    const newColumns = [];
    cancellationReportUIProps.columns.forEach(column => {
      const newColumn = {
        dataField: column.dataField,
        text: column.text,
        sort: column.sort,
        width: column.width,
        hidden: column.hidden,
        classes: column.classes,
        headerClasses: column.headerClasses,
        sortCaret: column.sortCaret,
        formatter: column.formatter,
        style: column.style
      };

      if (column.dataField === dataField) {
        newColumn.hidden = !column.hidden;
        setButtonStyle(dataField)(newColumn.hidden ? "success" : "light");
      }

      newColumns.push(newColumn);
    });    

    cancellationReportUIProps.setColumns(newColumns);
  }  
  
  return (
    <div className="mt-5">
      <h5 className="card-label">Filtrele</h5>
      <Table hover>
        <tbody>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${photoStyle}`}
                onClick={() => toggleHidden("photoStr")}
              >
                Fotoğraf
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${termStyle}`}
                onClick={() => toggleHidden("term")}
              >
                Dönem
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${dateStyle}`}
                onClick={() => toggleHidden("date")}
              >
                Tarih
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${gradeLevelNameStyle}`}
                onClick={() => toggleHidden("gradeLevelName")}
              >
                Sınıf Düzeyi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${gradeStyle}`}
                onClick={() => toggleHidden("grade")}
              >
                Sınıf
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${studentNumberStyle}`}
                onClick={() => toggleHidden("studentNumber")}
              >
                Öğrenci Numarası
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${tcKimlikNoStyle}`}
                onClick={() => toggleHidden("identityCard.tcKimlikNo")}
              >
                TC Kimlik No
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${nameStyle}`}
                onClick={() => toggleHidden("identityCard.name")}
              >
                Adı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${surnameStyle}`}
                onClick={() => toggleHidden("identityCard.surname")}
              >
                Soyadı
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${sexNameStyle}`}
                onClick={() => toggleHidden("sexName")}
              >
                Cinsiyeti
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${addressStyle}`}
                onClick={() => toggleHidden("address")}
              >
                Adres
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${fatherNameStyle}`}
                onClick={() => toggleHidden("father.name")}
              >
                Baba Adı Soyadı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${motherNameStyle}`}
                onClick={() => toggleHidden("mother.name")}
              >
                Anne Adı Soyadı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${fatherPhoneStyle}`}
                onClick={() => toggleHidden("father.phone1")}
              >
                Baba Telefonu
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${motherPhoneStyle}`}
                onClick={() => toggleHidden("mother.phone1")}
              >
                Anne Telefonu
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${fatherOccupationStyle}`}
                onClick={() => toggleHidden("father.occupation")}
              >
                Baba Mesleği
              </button>
            </td>            
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${motherOccupationStyle}`}
                onClick={() => toggleHidden("mother.occupation")}
              >
                Anne Mesleği
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${phoneStyle}`}
                onClick={() => toggleHidden("phone")}
              >
                Öğrenci Telefonu
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${explanationStyle}`}
                onClick={() => toggleHidden("explanation")}
              >
                Açıklama
              </button>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}